import React from 'react';
import styled from 'styled-components';
import ChangeVideos from '../../Videos/ChangeVideosList/ChangeVideos';

const ChangeMotivationVideos = () => {
  return (
    <React.Fragment>
      <MainTitle>Редактирование видео</MainTitle>
      <ChangeVideos />
    </React.Fragment>
  );
};

export default ChangeMotivationVideos;

const MainTitle = styled.h1`
  font-size: 24px;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/Components/Motivation/ChangeMotivationList/ChangeMotivationVideos.jsx